/**
 * Dispatches iOS only sync method for non-files.
 *
 * @example
 * // iOS only method to sync non-files from the server.
 * api.triggerNonFilesSync()
 */
export function triggerNonFilesSync(): Promise<void> {
  return this.API.request('trigger_non_files_sync')
}
